import React from 'react'
import MonitorSubmissions from '../notifications/MonitorSubmissions'
import { useContext } from 'react';
import DataContext from '../../context/DataContext';




const MonitorSubmission = () => {



  const { setFetcherror, auntheticatedUser } = useContext(DataContext);
  const user_id = auntheticatedUser?.id;

  const monitorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? false:true 
  return (
    <><MonitorSubmissions incidentTitle={!monitorinitiated ? "Monitor Submissions" : "My Submissions"} /></>
  )
}

export default MonitorSubmission